import './ListInspectionTemplate.style.less'
import HeaderComponent from '../../../../Components/HeaderComponent/HeaderComponent'
import ToolbarComponent from '../../../../Components/ToolbarComponent/ToolbarComponent'
import { useNavigate } from 'react-router-dom'
import TableInspectionTemplate from '../../../components/Table/TableInspectionTemplate/TableInspectionTemplate'
import { useMutation, useQuery } from 'react-query'
import {
  deleteTemplate,
  getInspectionTemplates,
} from '../../../template.transform'
import { useState } from 'react'

function ListTemplateType() {
  const navigate = useNavigate()
  const [searchText, setsearchText] = useState('')

  const { data, isLoading, refetch } = useQuery(
    ['[GET_ALL_TEMPLATES', searchText],
    async () => {
      const payload = {
        search: searchText,
      }
      return await getInspectionTemplates(payload)
    }
  )

  const deleteTemplateMutation = useMutation(async (id: string) => {
    await deleteTemplate(id)
    await refetch()
  })

  return (
    <>
      <HeaderComponent title="Inspection Templates" />
      <ToolbarComponent
        onSearch={setsearchText}
        onAdd={() =>
          navigate('/system-configure/template/add-inspection-template')
        }
        isSearch={true}
        buttonText="New Template"
      />
      <TableInspectionTemplate
        onDelete={async (id) => await deleteTemplateMutation.mutateAsync(id)}
        data={data}
        isLoading={isLoading || deleteTemplateMutation.isLoading}
      />
    </>
  )
}

export default ListTemplateType
